(function(angular) {
    'use strict';

    angular.module('aprima-core-ui').factory('MultiSelectListItemModal', [
        '$uibModal',
        MultiSelectListItemModal,
    ]);

    angular.module('aprima-core-ui').controller('MultiSelectListItemModalCtrl', [
        '_',
        '$uibModalInstance',
        'collection',
        'debounce',
        'formatter',
        'orderFn',
        'selectedItems',
        MultiSelectListItemModalCtrl,
    ]);

    function MultiSelectListItemModal(
        $modal
    ) {
        var service = {
            openModal: openModal,
        };

        return service;

        function openModal(collection, selectedItems, formatter, orderFn) {
            var modal = $modal.open({
                backdrop: 'static',
                templateUrl: '/core-ui/modal-views/multi-select-list-item-modal.html',
                controller: 'MultiSelectListItemModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    collection: function() {
                        return collection;
                    },
                    selectedItems: function() {
                        return selectedItems;
                    },
                    formatter: function() {
                        return formatter;
                    },
                    orderFn: function() {
                        return orderFn;
                    },
                },
            });

            return modal.result;
        }
    }

    function MultiSelectListItemModalCtrl(
        _,
        $modalInstance,
        collection,
        debounce,
        formatter,
        orderFn,
        selectedItems
    ) {
        var vm = this;

        vm.cancel = cancel;
        vm.done = done;
        vm.clear = debounce(100, clear);
        vm.load = debounce(200, loadData);
        vm.getItemOrder = getItemOrder;
        vm.countSelected = countSelected;
        vm.items = [];
        vm.formatter = formatter;

        activate();

        function activate() {
            loadData();
            orderFn = orderFn || _.identity;
        }

        function loadData() {
            vm.items = _.compact(collection);

            if(selectedItems) {
                _.intersectionBy(vm.items, selectedItems, 'Id').forEach(function(item) {
                    item.previouslySelected = true;
                    item.selected = true;
                });
            }
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        function clear() {
            if(!vm.items) {
                return;
            }

            _.forEach(vm.items, function(item) {
                if(item) {
                    item.selected = false;
                }
            });
        }

        function done() {
            var selected = _.filter(vm.items, 'selected');
            $modalInstance.close(selected);
        }

        function countSelected() {
            if(!vm.items) {
                return 0;
            }

            var count = _.sumBy(vm.items, function(val) {
                var num = val && val.selected ? 1 : 0;
                return num;
            });

            return count;
        }

        function getItemOrder(item) {
            if(!item) {
                return '2';
            }

            var order = '' + (item.previouslySelected ? 0 : 1) + orderFn(item);

            return order;
        }
    }

})(window.angular);